import rgba from 'polished/lib/color/rgba';
export const getDisabledColorOpacity = (color) => rgba(color, 0.5);
export const getHoverColorOpacity = (color) => rgba(color, 0.8);
